import LeadWizard from "./components/wizard/LeadWizard";
import SavedSearchWizard from "./components/wizard/SavedSearchWizard";
import ExposeInquiryWizardApp from "./components/wizard/ExposeInquiryWizardApp";
import ContactFormWizard from "./components/wizard/ContactFormWizard";
import NewsletterWizard from "./components/wizard/NewsletterWizard";
import Login from "./components/Login";

export default [
  { path: "/lead-wizard", component: LeadWizard },
  { path: "/saved-search-wizard", component: SavedSearchWizard },
  { path: "/expose-inquiry-wizard", component: ExposeInquiryWizardApp },
  { path: "/contact-form-wizard", component: ContactFormWizard },
  { path: "/newsletter-wizard", component: NewsletterWizard },
  { path: "/login", name: "home", component: Login }
];
